import { render, staticRenderFns } from "./teacherSessionCostList.vue?vue&type=template&id=2c84ff35&scoped=true&"
import script from "./teacherSessionCostList.vue?vue&type=script&lang=js&"
export * from "./teacherSessionCostList.vue?vue&type=script&lang=js&"
import style0 from "./teacherSessionCostList.vue?vue&type=style&index=0&id=2c84ff35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c84ff35",
  null
  
)

export default component.exports